<template>
  <div
    :id="`instruction_stage_${instruction.id}`"
    class="relative flex flex-col gap-2 py-3 pl-10 pr-3 border rounded min-h-24 bg-pure-white border-slate-400"
  >
    <div
      class="absolute flex flex-col items-center justify-between flex-shrink-0 py-3 rounded-l w-7"
      :style="{
        height: 'calc(100% + 2px)',
        top: '-1px',
        left: '-1px',
        background: 'linear-gradient(180deg, #F9FCE9 0%, #EEFDB1 100%)'
      }"
    >
      <div v-if="instruction.instruction_type === 'notes'">
        <BlIcon icon="paper-note" color="lime-6" class="w-4 h-4" />
      </div>
      <div v-if="instruction.instruction_type === 'todo'">
        <input type="checkbox" name="" id="" />
      </div>
      <div
        v-if="editable"
        class="h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-lime-400 cursor-pointer"
        @click="editOpened = true"
      >
        <BlIcon icon="edit" color="lime-6" class="w-4 h-4" />
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <div
        class="flex items-center justify-between gap-2 cursor-pointer"
        @click="chevronOpened = !chevronOpened"
      >
        <div class="flex truncate" :title="instruction.title">
          <BlTextSubtitle3 :text="instruction.title" class="truncate" />
        </div>
        <BlIcon
          v-if="showIcon"
          icon="chevron-down"
          class="w-5 h-5 transition-all duration-300"
          :style="{ rotate: chevronOpened ? '180deg' : '' }"
        />
      </div>
      <div class="flex">
        <div
          v-html="instruction.description"
          class="text-sm whitespace-pre-line text-slate-700"
          :class="{ 'line-clamp-2': !chevronOpened }"
        ></div>
      </div>
      <div
        v-if="chevronOpened && instruction.documents.length"
        class="flex flex-col gap-2 p-2 rounded bg-slate-200"
      >
        <BlFileHolder
          v-for="(doc, idx) in instruction.documents"
          :key="idx"
          :name="doc.blob.filename"
          :size="doc.blob.byte_size"
          :url="doc.file_url"
        />
      </div>
    </div>
    <EditInstructionStagePanel
      :open="editOpened"
      :instruction="instruction"
      :stage="stage"
      @close-panel="editOpened = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import EditInstructionStagePanel from "../modal/EditInstructionStagePanel.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlBubbleCount from "../../BlBubbleCount.vue";
import BlFileHolder from "../../BlFileHolder.vue";

export default {
  name: "PipelineInstructionStage",
  components: {
    EditInstructionStagePanel,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon,
    BlBubbleCount,
    BlFileHolder
  },
  props: {
    instruction: { type: Object, required: true },
    stage: { type: Object, default: null },
    editable: { type: Boolean, default: false }
  },
  data() {
    return {
      showIcon: false,
      chevronOpened: false,
      elementHeight: "6rem",
      editOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  watch: {
    editOpened() {
      this.chevronOpened = false;
    }
  },
  mounted() {
    this.showIcon = false;
    setTimeout(() => {
      this.showIcon = true;
    }, 1500);
  },
  methods: {
    ...mapActions([""]),
    displayDate(date, format) {
      if (!date) return "";
      return moment(date).format(format);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/pipeline/InstructionStage.vue